import { render } from "./AddOrEditStockProduct.vue?vue&type=template&id=22f0ea66&ts=true"
import script from "./AddOrEditStockProduct.vue?vue&type=script&lang=ts"
export * from "./AddOrEditStockProduct.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__